import {Component, ChangeDetectorRef, Input, inject} from '@angular/core';
import {Condition} from "../condition";
import {ConditionsService} from "../conditions.service";
import {MatButtonModule} from "@angular/material/button";
import {MatList, MatListItem} from "@angular/material/list";

@Component({
  selector: 'app-icon-credits-modal',
  templateUrl: './icon-credits-modal.component.html',
  imports: [
    MatButtonModule,
    MatListItem,
    MatList,
  ],
  styleUrls: ['./icon-credits-modal.component.scss']
})
export class IconCreditsModalComponent {
  conditionService = inject(ConditionsService);
  isOpen = false;
  credits: Condition[] = [];

  constructor(private cdr: ChangeDetectorRef) {
    this.conditionService.getAllConditions()
      .subscribe({
        next: (credits: Condition[]) => {
          this.credits = credits;
        },
        error: (error) => {
          console.error("Error fetching conditions:", error);
        }
      });
  }

  open(credits?: Condition[]) {
    if (credits) {
      this.credits = credits;
    }
    this.isOpen = true;
    this.cdr.detectChanges();
  }

  close() {
    this.isOpen = false;
    this.cdr.detectChanges();
  }
}
